import { useState, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { actions, setLocationErrorMessage } from '../store/ducks/yandexLocation.duck';

type CallbackType = {
  (lat: number, lng: number): void;
};

export const useCurrentLocation = (callback: CallbackType) => {
  const [coordinates, setCoordinates] = useState<string>('');
  const [error, setError] = useState<string>('');
  const dispatch = useDispatch();
  const intl = useIntl();

  const handleGetCurrentLocation = useCallback(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        position => {
          const { latitude, longitude } = position.coords;
          dispatch(actions.fetchCoordinatesRequest({ location: `${longitude}, ${latitude}` }));
          setCoordinates(`${latitude}, ${longitude}`);
          callback(latitude, longitude);
        },
        error => {
          setError(intl.formatMessage({ id: 'STORE.INPUT.LOCATION_ACCESS_DENIED' }));
          dispatch(
            setLocationErrorMessage(
              intl.formatMessage({ id: 'STORE.INPUT.LOCATION_ACCESS_DENIED' })
            )
          );
        }
      );
    } else {
      setError(intl.formatMessage({ id: 'STORE.INPUT.LOCATION_NOT_SUPPORTED_BROWSER' }));
      dispatch(
        setLocationErrorMessage(
          intl.formatMessage({ id: 'STORE.INPUT.LOCATION_NOT_SUPPORTED_BROWSER' })
        )
      );
    }
  }, [dispatch, intl]);

  return {
    coordinates,
    error,
    handleGetCurrentLocation,
  };
};
